<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ReviewProjectSubPage from '@/components/reviewProject/ReviewProjectSubPage.vue';
import ReviewProjectStatistics from '@/components/reviewProject/ReviewProjectStatistics.vue';

const route = useRoute();
const projectUid = computed(() => route.params.uid as string);
</script>

<template>
  <review-project-sub-page :project-uid="projectUid" title="Statistics">
    <ReviewProjectStatistics :project-uid="projectUid" />
  </review-project-sub-page>
</template>
